/* NMT desktop gallery arrows — 2026-07-12 (Steve request).
   Dawn hides its slider buttons on desktop and the desktop gallery isn't a slider,
   so these arrows step through the gallery by activating Dawn's own thumbnails
   (same code path as a thumbnail click, so hide_variants filtering and variant
   switching stay consistent). Desktop-only via CSS; mobile keeps native swipe. */
(function () {
  function init() {
    document.querySelectorAll('.product__media-wrapper').forEach(function (wrap) {
      if (wrap.dataset.nmtArrows) return;
      var thumbs = wrap.querySelectorAll('.thumbnail-list .thumbnail');
      if (thumbs.length < 2) return;
      var list = wrap.querySelector('ul.product__media-list');
      if (!list) return;
      var host = list.closest('slider-component') || list.parentElement;
      wrap.dataset.nmtArrows = '1';
      host.style.position = 'relative';
      // Point the arrows at the slide list they drive (WCAG carousel pattern). Dawn does not
      // give the list an id, so mint a stable one if it is missing.
      if (!list.id) list.id = 'nmt-gal-slides-' + (Math.floor(Math.random() * 1e6));
      ['prev', 'next'].forEach(function (dir) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'nmt-gal-arrow nmt-gal-' + dir;
        b.setAttribute('aria-label', dir === 'prev' ? 'Previous image' : 'Next image');
        b.setAttribute('aria-controls', list.id);
        // The chevron is decoration; the accessible name comes from aria-label above.
        b.textContent = dir === 'prev' ? '❮' : '❯';
        b.addEventListener('click', function (e) {
          e.preventDefault();
          var nativeBtn = wrap.querySelector('.slider-buttons button[name="' + (dir === 'prev' ? 'previous' : 'next') + '"]');
          if (nativeBtn && nativeBtn.offsetParent !== null) { nativeBtn.click(); return; }
          var visible = Array.prototype.filter.call(
            wrap.querySelectorAll('.thumbnail-list .thumbnail'),
            function (t) { return t.offsetParent !== null; }
          );
          if (!visible.length) return;
          var cur = visible.findIndex(function (t) { return t.getAttribute('aria-current') === 'true'; });
          if (cur < 0) cur = 0;
          var nxt = dir === 'prev' ? (cur - 1 + visible.length) % visible.length : (cur + 1) % visible.length;
          visible[nxt].click();
        });
        host.appendChild(b);
      });
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
